export default __webpack_public_path__ + "static/media/sy-fasj.d9955899.png";